import { render, staticRenderFns } from "./userLogsList.vue?vue&type=template&id=7328b556&scoped=true&"
import script from "./userLogsList.vue?vue&type=script&lang=js&"
export * from "./userLogsList.vue?vue&type=script&lang=js&"
import style0 from "./userLogsList.vue?vue&type=style&index=0&id=7328b556&lang=scss&scoped=true&"
import style1 from "./userLogsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7328b556",
  null
  
)

export default component.exports